import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { RoleProvider } from './contexts/RoleContext';
import { ThemeProvider, useThemeContext } from './contexts/ThemeContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import SubscriptionBanner from './components/Common/SubscriptionBanner';
import AppRouter from './routes/AppRouter';

const ThemedApp = () => {
  const { muiTheme } = useThemeContext();

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <RoleProvider>
            <CurrencyProvider>
              <SubscriptionProvider>
                <SubscriptionBanner />
                <AppRouter />
              </SubscriptionProvider>
            </CurrencyProvider>
          </RoleProvider>
        </AuthProvider>
      </Router>
    </MuiThemeProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  );
}

export default App;
